import { Link } from 'react-router-dom';
import { useCallback } from 'react';

export default function CtaSection() {
  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20with%20soft%20swirling%20shapes%20in%20coral%20and%20cream%20hues%2C%20minimalist%20elegant%20design%2C%20smooth%20flowing%20curves%2C%20dreamy%20atmosphere%2C%20clean%20aesthetic%2C%20no%20text&width=1800&height=700&seq=cta-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/20 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading text-background-50 mb-5">
            准备好了吗？立即开始免费建站
          </h2>
          <p className="text-base text-background-50/75 mb-10 leading-relaxed">
            无需编程，无需下载，打开浏览器即可开始。3分钟打造你的专属网站，永久免费使用。
          </p>
          <Link
            to="/category/all"
            onClick={scrollToTop}
            className="inline-flex items-center gap-2 px-10 py-4 text-base font-medium rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            免费开始建站
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}